export default function validate(values, props) {
    const { messages } = props
    const errors = {}

    if (!values.mobilePhone1 || !values.mobilePhone1.trim()) {
        errors.mobilePhone1 = messages.errors.required({})
    } else if (isNaN(values.mobilePhone1)) {
        errors.mobilePhone1 = messages.consentPhone.error()
    }
    return errors
}
